import React, {useEffect} from "react";
import {useHistoryList} from "./hooks/useHistoryList";
import {ListTable} from "../../../layout/content/list/ListTable";
import {ListCount, WhichList} from "../../../components/ListCount";
import {useHistoryFilters} from "./hooks/useHistoryFilters";
import {useHistoryColumn} from "./hooks/useHistoryColumn";

export function CounselorHistoryList() {

    const {
        counselorHistoryList,
        totalCounselorHistoryCount,
        pageCondition,
        searchCounselorHistoryList,
        onRefresh
    } = useHistoryList();

    const {filters} = useHistoryFilters({search: searchCounselorHistoryList({})});
    const {columns} = useHistoryColumn();

    useEffect(() => {
        // 이벤트 리스너 등록
        const handleRefresh = () => {
            onRefresh();

        };
        window.addEventListener('refreshCounselorData', handleRefresh);
        return () => {
            window.removeEventListener('refreshCounselorData', handleRefresh);
        };
        //eslint-disable-next-line
    }, [searchCounselorHistoryList, pageCondition]);

    return(
        <>
            {counselorHistoryList ? (
                <ListTable
                    filters={filters}
                    buttonsNode={<></>}
                    listData={counselorHistoryList}
                    getList={({page, sort, size}) => searchCounselorHistoryList({page, sort, size})}
                    columns={columns}
                    totalRowsCnt={{
                        totalCount: <ListCount totalCount={totalCounselorHistoryCount ?? 0} whichList={WhichList.COUNSELOR}/>,
                        singleUnitKeyInCommonFile: "counselorUnit.singleComponent",
                        multipleUnitKeyInCommonFile: "counselorUnit.multipleComponent",
                    }}
                    pageOnFilter={pageCondition}
                />
            ) : (
                <></>
            )}
        </>
    )
}